import { TwoFactorAuthTypesApiPaths } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

const client = new RestClient(TwoFactorAuthTypesApiPaths.GetApiAuth2fa, {}, resolveDomain(), { mode: 'cors', referrerPolicy: 'no-referrer' })

export const checkIs2FaEnabledHandler = async () => await client.get<boolean>('')
